<template>
    <section class="plugin-home-important">
        <div class="plugin-home-important__container">
            <div class="plugin-home-important__badge"
                 v-text="badge"
            />
            <div class="plugin-home-important__title"
                 v-text="title"
            />
            <div class="plugin-home-important__text" v-html="text" />
        </div>
    </section>
</template>

<script>
export default {
    name: 'plugin-home-important',
    props: {
        badge: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: null,
        },
    },
    methods: {
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-home-important {
    .container-landing();

    &__container {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        margin: 0 auto;

        max-width: @landing-max-width;
        padding: 32px 120px;

        border: 1px solid @color-gray-light-secondary;
        border-radius: @border-radius-xxl;
        background-color: white;
    }

    &__badge {
        .typography-medium();

        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);

        display: inline-block;
        background-color: @color-accent-negative;
        color: #ffffff;
        padding: 8px 16px;
        border-radius: 12px;
    }
    &__title {
        .typography-landing-title();
    }
    &__text {
        .typography-medium();

        text-align: center;
        /deep/ p {
            margin: 0;
        }
    }

    @media @media-md-down {
        &__container {
            padding: 24px;
        }
        &__badge {
            .typography-heading();
        }
        &__title {
            .typography-small();

            font-weight: bold;
        }
        &__text {
            .typography-heading();
        }
    }
}
</style>
